<style lang="scss">
  header {
    background-color: var(--color-white);
    padding: 12px 0 0;
  }
  img {
    display: block;
    margin: auto;
  }
</style>

<header>
  <img alt="Spara tid. Handla online." src="https://assets.icanet.se/image/upload/hssynge42nbcnum1v0ox.png" srcset="https://assets.icanet.se/image/upload/hssynge42nbcnum1v0ox.png, https://assets.icanet.se/image/upload/hssynge42nbcnum1v0ox.png 2x">
</header>
